import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import SearchBar from './SearchBar'
import VetInfo from './VetInfo'
import Authorize from '../../../components/Authorize'
import { fetchVeteranProfile } from '../actions/FetchVetInfoAction'

import '../style/vis-browser.scss'

export class VisBrowser extends Component {
  getProfile = (event) => {
    event.preventDefault()
    this.props.fetchVeteranProfile(event.target.value)
  }

  render() {
    let minmode = (this.props.minMode) ? 'min-mode' : ''
    return (
      <div className={`vis-browser usa-grid ${minmode}`}>
        <Authorize gearAuth={['VIS Browser']} gearName='Veterans Information Solution'>
          <h1 className='vis-h1'>Veterans Information Solution</h1>
          <SearchBar />
          <VetInfo getProfile={this.getProfile} {...this.props} />
        </Authorize>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  vetInfo: state.vetInfo
})

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ fetchVeteranProfile }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(VisBrowser)
